import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  Button as ShadcnButton,
  buttonVariants,
} from '#/modules/commonComponents/shadcn/ui/button';

/** ERP 樣式掛點（換皮只改此檔，禁止改 vendor） */
const BUTTON_ERP_CLASS = '';

/** outline＝secondary 加權；含 Dialog footer 取消 */
const BUTTON_OUTLINE_ERP_CLASS = 'border-gray-500 bg-gray-50 hover:bg-gray-100';

/** destructive＝實心紅底淺字（全站統一，與單據退回／刪除草稿同款） */
const BUTTON_DESTRUCTIVE_ERP_CLASS = 'bg-red-600 text-red-50 hover:bg-red-700 hover:text-white';

const Button = ({ className, variant, ...props }) => (
  <ShadcnButton
    variant={variant}
    className={cn(
      BUTTON_ERP_CLASS,
      variant === 'outline' && BUTTON_OUTLINE_ERP_CLASS,
      variant === 'destructive' && BUTTON_DESTRUCTIVE_ERP_CLASS,
      className,
    )}
    {...props}
  />
);

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

export { Button, buttonVariants };
